import { render, staticRenderFns } from "./get_dashboard.vue?vue&type=template&id=15835e26&"
import script from "./get_dashboard.vue?vue&type=script&lang=js&"
export * from "./get_dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports